import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';
import { Checkbox } from '../../../components/ui/Checkbox';

const PostsCardList = ({ 
  posts, 
  selectedPosts, 
  onSelectPost, 
  onEdit, 
  onToggleStatus, 
  onDelete 
}) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric', 
      year: 'numeric' 
    });
  };

  return (
    <div className="lg:hidden grid grid-cols-1 gap-4">
      {posts?.map((post) => (
        <div 
          key={post?.id} 
          className="bg-card border border-border rounded-lg overflow-hidden"
        >
          <div className="flex gap-4 p-4">
            <div className="flex-shrink-0">
              <Checkbox
                checked={selectedPosts?.includes(post?.id)}
                onChange={(e) => onSelectPost(post?.id, e?.target?.checked)}
              />
            </div>
            <div className="flex-shrink-0 w-20 h-20 md:w-24 md:h-24 rounded-lg overflow-hidden bg-muted">
              <Image
                src={post?.heroImage}
                alt={post?.heroImageAlt}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-base md:text-lg font-semibold text-foreground line-clamp-2 mb-2">
                {post?.title}
              </h3>
              <p className="text-sm text-muted-foreground line-clamp-2 mb-3">
                {post?.excerpt}
              </p>
              <div className="flex flex-wrap items-center gap-3 text-xs text-muted-foreground">
                <div className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full font-medium ${
                  post?.status === 'published' ?'bg-accent/10 text-accent' :'bg-muted text-muted-foreground'
                }`}>
                  <Icon 
                    name={post?.status === 'published' ? 'CheckCircle2' : 'Clock'} 
                    size={12} 
                    color="currentColor" 
                  />
                  {post?.status === 'published' ? 'Published' : 'Draft'}
                </div>
                <span>{post?.author}</span>
              </div>
            </div>
          </div>
          
          <div className="border-t border-border p-4">
            <div className="flex items-center justify-between mb-3 text-xs text-muted-foreground">
              <div className="flex items-center gap-1">
                <Icon name="Calendar" size={12} color="currentColor" />
                <span>Created: {formatDate(post?.createdAt)}</span>
              </div>
              <div className="flex items-center gap-1">
                <Icon name="Clock" size={12} color="currentColor" />
                <span>Modified: {formatDate(post?.updatedAt)}</span>
              </div>
            </div>
            
            <div className="flex items-center gap-2">
              <Button
                variant="outline"
                size="sm"
                onClick={() => onEdit(post?.id)}
                iconName="Edit"
                iconPosition="left"
                iconSize={14}
                fullWidth
              >
                Edit
              </Button>
              <Button
                variant="outline"
                size="sm"
                onClick={() => onToggleStatus(post?.id)}
                iconName={post?.status === 'published' ? 'EyeOff' : 'Eye'}
                iconPosition="left"
                iconSize={14}
                fullWidth
              >
                {post?.status === 'published' ? 'Unpublish' : 'Publish'}
              </Button>
              <Button
                variant="outline"
                size="sm"
                onClick={() => onDelete(post?.id)}
                iconName="Trash2"
                iconSize={14}
              >
                <span className="sr-only">Delete</span>
              </Button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PostsCardList;